module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_1.79a8d140.png";